module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "walnut-cove-abstract-hayman-1.f2960cee.jpg";